import React from 'react'

export default function OrderSearchBox({
  onClickSearch,
  handleOnSearch,
  workingStatus,
  setOrderNo,
  orderNo,
  setUserNo,
  userNo,
  setFirstName,
  firstName,
  setLastName,
  lastName,
  setSort,
  sort,
  sortRef,
  setPhoneNo,
  phoneNo,
}) {
  const handleOnChangeOrderNo = (e) => setOrderNo(e.target.value)
  const handleOnChangeUserNo = (e) => {
    let text = e.target.value
    setUserNo(text.trim())
  }
  const handleOnChangePhoneNo = (e) => {
    const inputPhoneNo = e.target.value.replaceAll('-', '').trim()
    const isNumber = RegExp(/^\d+$/).test(inputPhoneNo)
    if (isNumber || inputPhoneNo === '') {
      setPhoneNo(inputPhoneNo)
    }
  }
  const handleOnChangeFirstName = (e) => setFirstName(e.target.value)
  const handleOnChangeLastName = (e) => setLastName(e.target.value)
  const handleOnChangeSort = (e) => {
    sortRef.current = e.target.value
    setSort(e.target.value)
  }
  const clearFilter = () => {
    setOrderNo('')
    setUserNo('')
    setFirstName('')
    setLastName('')
    setSort('ASC')
    setPhoneNo('')
  }

  return (
    <>
      <div className="d-flex pt-2 pb-2">
        <input
          name="orderNo"
          type="text"
          placeholder="หมายเลขคำสั่งซื้อ"
          value={orderNo || ''}
          className="form-control mr-2"
          style={{ color: '#5d5d5d' }}
          onChange={handleOnChangeOrderNo}
          onKeyDown={(e) => handleOnSearch(e)}
        />
        <input
          name="userId"
          type="text"
          placeholder="รหัสสมาชิก"
          value={userNo || ''}
          className="form-control mr-2"
          style={{ color: '#5d5d5d' }}
          onChange={handleOnChangeUserNo}
          onKeyDown={(e) => handleOnSearch(e)}
        />
        <input
          name="phoneNo"
          type="text"
          placeholder="เบอร์โทรศัพท์"
          value={phoneNo || ''}
          className="form-control mr-2"
          style={{ color: '#5d5d5d' }}
          onChange={handleOnChangePhoneNo}
          onKeyDown={(e) => handleOnSearch(e)}
        />
        <input
          name="firstName"
          type="text"
          placeholder="ชื่อ"
          value={firstName || ''}
          className="form-control mr-2"
          style={{ color: '#5d5d5d' }}
          onChange={handleOnChangeFirstName}
          onKeyDown={(e) => handleOnSearch(e)}
        />
        <input
          name="lastName"
          type="text"
          placeholder="นามสกุล"
          value={lastName || ''}
          className="form-control mr-2"
          style={{ color: '#5d5d5d' }}
          onChange={handleOnChangeLastName}
          onKeyDown={(e) => handleOnSearch(e)}
        />
        <select placeholder="sort" className="form-control mr-2" value={sort} onChange={handleOnChangeSort}>
          <option value="DESC">ล่าสุด</option>
          <option value="ASC">เก่าสุด</option>
        </select>
        <div
          className="btn btn-secondary"
          style={{ minWidth: '200px', marginRight: '0.5rem' }}
          onClick={() => clearFilter()}
        >
          ล้างตัวกรอง
        </div>
        <div
          className="btn btn-primary"
          style={{ minWidth: '120px' }}
          onClick={() => {
            handleOnSearch({ code: 'Enter' })
          }}
        >
          ค้นหา
        </div>
      </div>
    </>
  )
}
